import {ToolbarButton} from '@mui/x-data-grid';
import {Tooltip, useTheme} from '@mui/material';
import FilterIcon from '~/components/icons/svg/FilterIcon.svg?react';

export type DataGridHeaderFiltersToggleButtonProps = {
    visible: boolean;
    onToggle: () => void;
};

export const DataGridHeaderFiltersToggleButton = ({
                                                      visible,
                                                      onToggle,
                                                  }: DataGridHeaderFiltersToggleButtonProps) => {
    const theme = useTheme();

    return (
        <Tooltip title={visible ? 'Hide column filters' : 'Show column filters'}>
            <ToolbarButton
                color="primary"
                aria-pressed={visible}
                aria-label={visible ? 'Hide column filters' : 'Show column filters'}
                onClick={onToggle}
                style={visible ? {backgroundColor: theme.palette.action.selected} : undefined}
            >
                <FilterIcon fontSize="small"/>
            </ToolbarButton>
        </Tooltip>
    );
};
